#@export UrgencyTimer.Helpers

timeRemaining = (timeRemainingMilliseconds) ->
  return {days:0, hours:0, minutes:0, seconds:0} unless timeRemainingMilliseconds?
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24))
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24))
  hours = Math.floor(millisecondsLeft / (1000 * 3600))
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600))
  minutes = Math.floor(millisecondsLeft / (1000 * 60))
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60)
  seconds = Math.floor(millisecondsLeft / 1000)
  {days, hours, minutes, seconds}

millisRemaining = (endTime) ->
  return 0 unless endTime?
  rightNow = new Date().getTime()
  millsRemaining = endTime - rightNow
  if millsRemaining < 0 then 0 else millsRemaining

addLeadingZero = (number) ->
  return if number < 0
  if number < 10 then "0#{number}" else "#{number}"

countdownTimeKey = (timeLeft, ignoreCap = false) ->
  switch
    when timeLeft.days >= 15 and not ignoreCap then ""
    when timeLeft.days > 1 then ".countdown_time_many_days"
    when timeLeft.days is 1 then ".countdown_time_1_day"
    else ".countdown_time_today"

countdownTimestamp = (timeLeft) ->
  hh = addLeadingZero timeLeft.hours
  mm = addLeadingZero timeLeft.minutes
  ss = addLeadingZero timeLeft.seconds
  "#{hh}:#{mm}:#{ss}"

if window?
  window.UrgencyTimer ?= {}
  UrgencyTimer.Helpers?= {}
  UrgencyTimer.Helpers.timeRemaining= timeRemaining
  UrgencyTimer.Helpers.millisRemaining = millisRemaining
  UrgencyTimer.Helpers.countdownTimeKey = countdownTimeKey
  UrgencyTimer.Helpers.countdownTimestamp = countdownTimestamp

if module?
  module.exports = {timeRemaining, millisRemaining, countdownTimeKey, countdownTimestamp}
